<!--
 * @Description: 请输入当前文件描述
 * @Author: ChangWenBo (649160016@qq.com)
 * @Date: 2021-03-25 17:44:43
 * @LastEditors: ChangWenBo (649160016@qq.com)
 * @LastEditTime: 2021-04-20 11:33:02
 -->
<template>
  <div class="leftPart">
    <div class="left-top">
      <div class="titleHeader">
        <img src="/static/img/layout/arrow-orange.png" alt="">
        <span class="titleName">设备状态</span>
      </div>
      <div class="content">
        <div class="itemContainer">
          <div class="item">
            <img src="/static/img/layout/totalDevice.png" alt="">
            <div class="count">
              <div class="value">{{deviceStatusData.total}}</div>
              <div class="label">设备总数</div>
            </div>
          </div>
        </div>
        <div class="itemContainer">
          <div class="item">
            <img src="/static/img/layout/accessDevice.png" alt="">
            <div class="count">
              <div class="value">{{deviceStatusData.joined}}</div>
              <div class="label">接入平台数量</div>
            </div>
          </div>
        </div>
        <div class="itemContainer">
          <div class="item">
            <img src="/static/img/layout/onlineDevice.png" alt="">
            <div class="count">
              <div class="value">{{deviceStatusData.online}}</div>
              <div class="label">设备在线</div>
            </div>
          </div>
        </div>
        <div class="itemContainer">
          <div class="item">
            <img src="/static/img/layout/abnormalDevice.png" alt="">
            <div class="count">
              <div class="value">{{deviceStatusData.fail}}</div>
              <div class="label">设备异常</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="left-bottom">
      <div class="titleHeader">
        <img src="/static/img/layout/arrow-orange.png" alt="">
        <span class="titleName">日掉线次数</span>
      </div>
      <div class="offlineCharts" ref="offlineCharts"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'leftPart',
  components: {
  },
  data () {
    return {
      deviceStatusData: {},
      charts: '',
      xAxis: [],
      yAxis: [],
    }
  },
  methods: {
    /**
     * @description                   初始化图表
     * @return {undefied}             无返回值
     */
    initCharts () {
      this.charts = this.$echarts.init(this.$refs.offlineCharts)
      let options = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999',
            },
          },
        },
        xAxis: {
          type: 'category',
          data: this.xAxis,
          nameTextStyle: {
            color: '#fff',
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: '#32444B',
            },
          },
          splitLine: {
            show: false,
            lineStyle: {
              color: '#32444B',
              type: 'dashed',
            },
          },
          axisLabel: {
            textStyle: {
              color: '#fff',
            },
          },
        },
        yAxis: {
          name: '掉线次数（次）',
          type: 'value',
          nameTextStyle: {
            color: '#fff',
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: '#32444B',
            },
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: '#32444B',
              type: 'dashed',
            },
          },
          axisLabel: {
            textStyle: {
              color: '#fff',
            },
          },
        },
        series: [{
          data: this.yAxis,
          type: 'line',
          color: '#eceb50',
          symbol: 'circle',
          symbolSize: 8,
          lineStyle: {
            color: '#eceb50',
          },
        }],
      }
      this.charts.setOption(options)
      window.onresize = () => {
        this.charts.resize()
      }
    },
    /**
     * @description                   获取设备状态数据
     * @return {undefied}             无返回值
     */
    getDeviceStatusData () {
      this.$http.get('/rest/screen/hlpz/device/summary')
        .then(res => {
          if (res.code === 0) {
            this.deviceStatusData = res.data
          } else {
            this.$message({
              message: res.msg,
              type: 'error',
            })
          }
        })
    },
    /**
     * @description                   获取日掉线次数数据
     * @return {undefied}             无返回值
     */
    getOfflineTimesData () {
      this.$http.get('/rest/screen/hlpz/device/offline')
        .then(res => {
          if (res.code === 0) {
            let xAxis = []
            let yAxis = []
            res.data.map(k => {
              xAxis.push(k.time)
              yAxis.push(k.number)
            })
            this.xAxis = xAxis
            this.yAxis = yAxis
            this.initCharts()
          } else {
            this.$message({
              message: res.msg,
              type: 'error',
            })
          }
        })
    },
  },
  mounted () {
    this.getOfflineTimesData()
  },
  created () {
    this.getDeviceStatusData()
  },
}
</script>

<style lang="less" scoped>
  .leftPart {
    width: 100%;
    height: 100%;
    .left-top {
      width: 100%;
      height: 40%;
      .titleHeader {
        width: 100%;
        height: 4vh;
        background: url('/static/img/layout/titleHeaderBg.png');
        background-size: 100% 100%;
        display: flex;
        align-items: center;
        >img {
          height: 100%;
          margin-right: 20px;
        }
        .titleName {
          font-family: SourceHanSansCN-Bold;
          font-size: 1.5vh;
          font-weight: normal;
          font-stretch: normal;
          letter-spacing: 0px;
          color: #05dbe3;
        }
      }
      .content {
        width: 100%;
        height: 90%;
        background: url('/static/img/layout/crossBg.png');
        background-size: 100% 100%;
        .itemContainer {
          width: 50%;
          height: 50%;
          display: inline-block;
          .item {
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: space-around;
            align-items: center;
            img {
              width: 45%;
            }
            .count {
              font-size: 1.6vh;
              text-align: center;
              .value {
                color: #05dbe3;
                font-weight: bold;
                margin-bottom: 1vh;
              }
              .label {
                color: #ededed;
                font-size: 1.5vh;
              }
            }
            &:nth-of-type(3) {
              .count {
                .value {
                  color: #49df59;
                }
              }
            }
            &:nth-of-type(4) {
              .count {
                .value {
                  color: #e93d34;
                }
              }
            }
          }
        }
      }
    }
    .left-bottom {
      width: 100%;
      height: 60%;
      .titleHeader {
        width: 100%;
        height: 4vh;
        background: url('/static/img/layout/titleHeaderBg.png');
        background-size: 100% 100%;
        display: flex;
        align-items: center;
        >img {
          height: 100%;
          margin-right: 20px;
        }
        .titleName {
          font-family: SourceHanSansCN-Bold;
          font-size: 1.5vh;
          font-weight: normal;
          font-stretch: normal;
          letter-spacing: 0px;
          color: #05dbe3;
        }
      }
      .offlineCharts {
        width: 100%;
        height: 90%;
      }
    }
  }
</style>
